import React from 'react';

export const Marker = () => (
  <g
    transform="matrix(46.956522,0,0,46.956522,211.30435,-3.0000001e-6)"
    strokeWidth="0.0212963"
  >
    <path
      fill="#1875f0"
      strokeWidth="0.0212963"
      d="M 7,3 C 4.8,3 3,4.8 3,7 H 5 C 5,5.883 5.883,5 7,5 Z M 7,2 c 2.773,0 5,2.227 5,5 0,2.773 -2.227,5 -5,5 C 4.227,12 2,9.773 2,7 2,4.227 4.227,2 7,2 Z M 7,0 C 3.145,0 0,3.145 0,7 c 0,3.516 2.617,6.418 6,6.906 V 23 H 8 V 13.906 C 11.383,13.418 14,10.516 14,7 14,3.145 10.855,0 7,0 Z"
    />
  </g>
);
